module.exports = __webpack_public_path__ + "media/images/smiley_geduld-cde38ba8743049bdbd1e24c414605825.gif";